import { render } from "./aceyDuecey.vue?vue&type=template&id=d1decbda&scoped=true"
import script from "./aceyDuecey.vue?vue&type=script&lang=js"
export * from "./aceyDuecey.vue?vue&type=script&lang=js"

import "./aceyDuecey.vue?vue&type=style&index=0&id=d1decbda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1decbda"]])

export default __exports__